import * as React from 'react';
import { observer } from 'mobx-react';

import { Viewport, ViewLarge, ViewSmall } from 'bernie-view';
import { UitkSelect } from 'uitk-react-select';
import { getAgeOptionsDataTestId } from 'utility';

import {
  TravelerOptionItem,
  FlightsTravelerAgeSelector,
  FlightsSearchFormTravelerAgeOptionItem
} from 'types/search/wizard';

export interface TravelerAgeInputsProps {
  travelerOptionItem: TravelerOptionItem;
}

const getChildAgeOptions = (items: FlightsSearchFormTravelerAgeOptionItem[]) => {
  return items.map(item => {
    if (item.value >= 0) {
      return (
        <option key={item.value} value={item.value}>
          {item.label}
        </option>
      );
    }
  });
};

export const TravelerAgeInputs = observer(({ travelerOptionItem }: TravelerAgeInputsProps) => {
  const { type, travelerAges } = travelerOptionItem;
  const ageInputGridClasses = 'uitk-grid all-x-gutter-three all-y-gutter-three all-y-margin-three';

  const inputs =
    travelerAges &&
    travelerAges.map((age: FlightsTravelerAgeSelector, index: number) => {
      const itemNumber = index + 1;
      const key = `${type}-age-select-${itemNumber}`;
      const labelTemplate = age.label.template;
      const labelToken = labelTemplate.match(/\{(.*)\}/)[0];
      const label = `${labelTemplate.replace(labelToken, itemNumber.toString(10))}`;
      const dataTestId = getAgeOptionsDataTestId(labelTemplate, labelToken, index);
      const selectedItem = age.items.find((item: FlightsSearchFormTravelerAgeOptionItem) => item.selected);
      const selectedValue = selectedItem && selectedItem.value.toString();
      const placeholder = selectedValue ? undefined : age.placeholder;

      const updateChildAge = (event: React.ChangeEvent) => {
        const target = event.target as HTMLInputElement;
        const value = parseInt(target.value, 10);
        const selectedAge = age.items.find((item: FlightsSearchFormTravelerAgeOptionItem) => item.selected);

        if (selectedAge) {
          selectedAge.selected = false;
        }

        age.items.find((item: FlightsSearchFormTravelerAgeOptionItem) => item.value === value).selected = true;
      };

      return (
        <div key={key} className="uitk-cell">
          <UitkSelect
            label={label}
            data-test-id={dataTestId}
            onChange={updateChildAge}
            value={selectedValue}
            placeholder={placeholder}
          >
            {getChildAgeOptions(age.items)}
          </UitkSelect>
        </div>
      );
    });

  return (
    <div className="all-y-margin-two">
      <Viewport>
        <ViewLarge>
          <div className={`${ageInputGridClasses} all-cell-1-1`}>{inputs}</div>
        </ViewLarge>
        <ViewSmall>
          <div className={`${ageInputGridClasses} all-cell-1-2`}>{inputs}</div>
        </ViewSmall>
      </Viewport>
    </div>
  );
});
